import { Component, OnInit } from '@angular/core'
import { CrmAssignee, Prospect, ProspectSource, ProspectSourceLabels, ProspectStatus, ProspectStatusLabels, ProspectType, ProspectTypeLabels } from '@parkupp/core'
import { ProspectingService, ProspectArea } from 'src/app/services/prospecting.service'
import { ProspectModalService } from '../prospect-modal/prospect-modal.service'

@Component({
    selector: 'app-admin-prospecting-table',
    templateUrl: './admin-prospecting-table.component.html',
    styleUrls: ['./admin-prospecting-table.component.scss'],
})
export class AdminProspectingTableComponent implements OnInit {
    allProspects: Prospect[] = []
    filtered: Prospect[] = []
    loading = true

    search = ''
    statusFilter = ''
    areaFilter = ''
    enrichedFilter = ''
    assigneeFilter = ''
    sourceFilter = ''
    searchTermFilter = ''
    prospectTypeFilter = ''
    sortBy: 'name' | 'distance' | 'created' = 'created'

    statusOptions = Object.values(ProspectStatus)
    statusLabels = ProspectStatusLabels
    sourceOptions = Object.values(ProspectSource)
    sourceLabels = ProspectSourceLabels
    prospectTypeOptions = Object.values(ProspectType)
    prospectTypeLabels = ProspectTypeLabels
    searchTermOptions: string[] = []
    areas: ProspectArea[] = []
    assignees: CrmAssignee[] = []

    constructor(private prospecting: ProspectingService, private modal: ProspectModalService) {}

    openProspect(p: Prospect): void {
        if (p.$key) this.modal.open(p.$key)
    }

    async ngOnInit(): Promise<void> {
        this.prospecting.getConfig().then((c) => (this.areas = c.areas)).catch(() => {})
        this.prospecting.listProspectingAssignees().subscribe((a) => (this.assignees = a))
        try {
            this.allProspects = await this.prospecting.listProspects()
            this.searchTermOptions = [...new Set(this.allProspects.map((p) => p.searchTerm).filter(Boolean) as string[])].sort()
            this.applyFilters()
        } catch (e) {
            console.error('Error loading prospects:', e)
        } finally {
            this.loading = false
        }
    }

    applyFilters(): void {
        const term = this.search.trim().toLowerCase()
        let list = this.allProspects.filter((p) => {
            if (term && !(`${p.name} ${p.domain || ''} ${p.fullAddress || ''}`.toLowerCase().includes(term))) return false
            if (this.statusFilter && p.status !== this.statusFilter) return false
            if (this.areaFilter && p.area !== this.areaFilter) return false
            if (this.enrichedFilter === 'yes' && !p.hunterEnriched) return false
            if (this.enrichedFilter === 'no' && p.hunterEnriched) return false
            if (this.assigneeFilter && p.assignedToUid !== this.assigneeFilter) return false
            if (this.sourceFilter && p.source !== this.sourceFilter) return false
            if (this.searchTermFilter && p.searchTerm !== this.searchTermFilter) return false
            if (this.prospectTypeFilter && p.prospectType !== this.prospectTypeFilter) return false
            return true
        })

        list = list.sort((a, b) => {
            if (this.sortBy === 'name') return (a.name || '').localeCompare(b.name || '')
            if (this.sortBy === 'distance') return this.nearestKm(a) - this.nearestKm(b)
            return 0 // already sorted by created desc from the query
        })

        this.filtered = list
    }

    nearestKm(p: Prospect): number {
        if (!p.nearestParkings || !p.nearestParkings.length) return Number.MAX_SAFE_INTEGER
        return p.nearestParkings[0].distanceKm
    }

    nearestLabel(p: Prospect): string {
        if (!p.nearestParkings || !p.nearestParkings.length) return '-'
        const n = p.nearestParkings[0]
        return `${n.distanceKm} km - ${n.parkingName}`
    }

    statusLabel(p: Prospect): string {
        return this.statusLabels[p.status] || p.status
    }

    areaName(slug?: string): string {
        return this.areas.find((a) => a.slug === slug)?.name || slug || '-'
    }
}
